import React, { useState, useRef, useEffect } from "react";
import { FaEye, FaTrash } from "react-icons/fa";
import { FaAngleLeft, FaAngleRight, FaPencil } from "react-icons/fa6";
import axios from "axios";
import { toast } from "react-toastify";
import BaseUrl from "../../base-api";
import { useNavigate } from "react-router-dom";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import Loader from "../Loader/Loader";
import { useDispatch } from "react-redux";
import { isloading } from "../redux/reducer/LoadingReducer";
import AxiosInstance from "../Utility/AxiosInstance";
import { getPageNumbers } from "../Utility/pagination";

const Notifications = () => {
  const [notifications, setNotifications] = useState([]);
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
const dispatch = useDispatch();

  const [viewNotifications, setViewNotifications] = useState([]); 
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10); 
    const [totalItems, setTotalItems] = useState(0);
    const [searchQuery, setSearchQuery] = useState("");
 const [totalPages, setTotalPages] = useState(1);
  const fetchLinks = async (pageNumber = currentPage) => {
    setSearchQuery("");
    setCurrentPage(1);
    const backendPage = pageNumber - 1;
    const token = sessionStorage.getItem("userToken");
    if (!token) return navigate("/login");
 
    try {
      const resLocation = await AxiosInstance.get(
        `${BaseUrl}/api/master/notificationType`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: token,
          },
        }
      );

      if (resLocation.data.status === 200) {
        const locationTypes = resLocation.data.data.map((item) => item.type);
        setLocations(locationTypes);
      } else {
        toast.error("Failed to fetch locations.");
      }

      const res = await AxiosInstance.post(
        `${BaseUrl}/api/notifications/getNotification`,
        { location: "All" },
        {
          params: {
            page: backendPage,
            size: itemsPerPage,
          },
        }
      );

      if (res.data.status === 200) {
        setNotifications(
          res.data.data.content.map((img) => ({
            id: img.key,
            title: img.title,
            file: `data:application/pdf;base64,${img.file}` || "",
            location: img.location,
            submissionDate: img.submissionDate,
          }))
        );

         setTotalPages(res.data.data.totalPages);
        setTotalItems(res.data.data.totalItems);
        setCurrentPage(pageNumber);
       
      } else {
        toast.error("Failed to fetch links.");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "An error occurred");
    } finally {
      dispatch(isloading(false));
    }
  };

 const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, totalItems);

  useEffect(() => {
     dispatch(isloading(true));
    fetchLinks();
  }, []);

  useEffect(() => {
    setViewNotifications(notifications.slice(0, itemsPerPage));
    }, [notifications]);



    const handlePageChange = (pageNumber) => {
     
       if (pageNumber > 0 && pageNumber <= totalPages) {
      fetchLinks(pageNumber);
    }
    };
  
    const handleNextPage = () => {
        handlePageChange(currentPage + 1);
    };
  
    const handlePreviousPage = () => {
            handlePageChange(currentPage - 1);
      };

  const [newNotification, setNewNotification] = useState({});
  const fileInputRef = useRef(null);
  const modalfileInputRef = useRef(null);
  const [currentNotification, setCurrentNotification] = useState(null);
  const [editTitle, setEditTitle] = useState("");
  const [currentEditId, setCurrentEditId] = useState("");
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  // View Notification
  const handleView = async (documentId) => {
  const notification = notifications.find((item) => item.id === documentId);
  const token = sessionStorage.getItem("userToken");
dispatch(isloading(true))
  try {


      const response = await fetch(
        `${BaseUrl}/api/notifications/document/${documentId}`,
         {
          method: "GET",
      headers: {
        Authorization: token,
      },
         }
      );
    
    if (!response.ok) {
      if (response.status === 404) {
        toast.error("Document not found.");
      } else {
        toast.error("Failed to load the document.");
      }
      return;
    }

    const blob = await response.blob();
    const fileUrl = URL.createObjectURL(blob);

    setCurrentNotification({
      ...notification,
      file: fileUrl,
    });

    setIsViewModalOpen(true);
  } catch (error) {
    console.error("Error loading file:", error);
    toast.error("An unexpected error occurred while opening the document.");
  }
  finally{
    dispatch(isloading(false))
  }
};

  // Edit Notification
  const handleEdit = (id) => {
    const notification = notifications.find((item) => item.id === id);
    setCurrentNotification(notification);
    setEditTitle(notification.title);
    setCurrentEditId(id);
    setIsEditModalOpen(true);
  };

  // Delete Notification
  const handleDelete = async (id) => {
    const toastId = toast.warn(
      <div
        style={{ textAlign: "center", fontSize: "18px", fontWeight: "bold" }}
      >
        <p>Are you sure you want to delete this notification?</p>
        <div className="d-flex justify-content-center">
          <button
            className="btn btn-danger btn-sm mx-2"
            onClick={() => confirmDelete(id, toastId)}
          >
            Yes
          </button>
          <button
            className="btn btn-secondary btn-sm"
            onClick={() => toast.dismiss(toastId)}
          >
            No
          </button>
        </div>
      </div>,
      {
        autoClose: false,
        closeOnClick: false,
        toastClassName: "toast-container",
        closeButton: false,
      }
    );
  };

  const confirmDelete = async (id, toastId) => {
    toast.dismiss(toastId); // Close confirmation toast
    const loadingToast = toast.loading("Deleting notification...");
    dispatch(isloading(true));
    try {
      const token = sessionStorage.getItem("userToken");
      const res = await axios.post(
        `${BaseUrl}/api/notifications/deleteNotification`,
        { key: id },
        {
          headers: { "Content-Type": "application/json", Authorization: token },
        }
      );

      toast.dismiss(loadingToast);
      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks();
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.dismiss(loadingToast);
      toast.error("Error deleting notification.");
    } finally {
      dispatch(isloading(false));
    }
  };

  const handleTitleChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      title: e.target.value,
    }));
  };
  const handleDateChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      submissionDate: e.target.value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validTypes = ["application/pdf"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an PDF.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        if (fileInputRef.current) fileInputRef.current.value = "";
        return;
      }
      setNewNotification((prevState) => ({ ...prevState, file }));
    }
  };

  const handleSave = async () => {
   
    if (
      newNotification.title &&
      newNotification.file &&
      newNotification.location
    ) {
      const token = sessionStorage.getItem("userToken");

      if(newNotification.location !=="Home Page"){
        if(!newNotification.submissionDate){
          toast.error("Last submission date is required for tenders and archived tenders.")
          return;
        }
    }

      const formData = new FormData();
      formData.append("multipart", newNotification.file);
      formData.append("title", newNotification.title);
      formData.append("location", newNotification.location);
      formData.append("submissionDate", newNotification.submissionDate);
      dispatch(isloading(true));
      try {
        const res = await axios.post(
          `${BaseUrl}/api/notifications/create`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/formData",
              Authorization: token,
            },
          }
        );

        if (res.data.status === 200) {
          
          toast.success(res.data.message);

         fetchLinks();
        } else {
          toast.error(res.data.message);
        }

     
        setNewNotification({ title: "", file: null, location: "",submissionDate:"" });
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; 
        }
      } catch (error) {
        toast.error("Error creating the notification.");
        setNewNotification({ title: "", file: null, location: "",submissionDate:""  });
        if (fileInputRef.current) {
          fileInputRef.current.value = ""; 
        }
      } finally {
        dispatch(isloading(false));
      }
    } 
   
    else {
      toast.error("Please fill in the all required fields.");
    }
  };

  const handleEditSave = async () => {
    if (editTitle.trim() === "") {
      toast.error("Title cannot be empty.");
      return;
    }

    if (!currentNotification.location) {
      toast.error("Location cannot be empty.");
      return;
    }
    if(currentNotification.location !=="Home Page"){
      if(!currentNotification.submissionDate){
        toast.error("Last submission date is required for tenders and archived tenders.")
        return;
      }
  }

    const token = sessionStorage.getItem("userToken");
    const formData = new FormData();
    formData.append("title", editTitle);
    formData.append("key", currentEditId);
    formData.append("location", currentNotification.location);
    formData.append("submissionDate", currentNotification.submissionDate);

    if (modalfileInputRef.current.files[0]) {
      const file = modalfileInputRef.current.files[0];
      const validTypes = ["application/pdf"];

      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload a PDF.");
        modalfileInputRef.current.value = ""; // Reset file input
        return;
      }
      if (file.size > 1 * 1024 * 1024) {
        toast.error("File size exceeds 1MB.");
        modalfileInputRef.current.value = "";
        return;
      }
      formData.append("multipart", file);
    } 
    // else {
    //   toast.error("File cannot be empty.");
    //   return;
    // }
    dispatch(isloading(true));
    try {
      const res = await axios.post(
        `${BaseUrl}/api/notifications/updateNotification`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: token,
          },
        }
      );

      if (res.data.status === 200) {
        toast.success(res.data.message);
        fetchLinks(); 
        setIsEditModalOpen(false);
      } else {
        toast.error(res.data.message);
      }
    } catch (error) {
      toast.error("Error updating the notification.");
    } finally {
      dispatch(isloading(false));
    }
  };

  const handleLocationChange = (e) => {
    setNewNotification((prevState) => ({
      ...prevState,
      location: e.target.value,
    }));
  };


  const handleSearch = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
  
    const filteredLinks = notifications.filter(
      (link) =>
        link.title.toLowerCase().includes(query) ||
        link.location.toLowerCase().includes(query) ||
        link.submissionDate.toLowerCase().includes(query) 
    );
  
    setTotalItems(filteredLinks.length);
    setCurrentPage(1); 
    setViewNotifications(filteredLinks.slice(0, itemsPerPage));
  };
  return (
    
        <div className="home-dashboard">
          <div className="ticket-tab">
          <h3>Upload Notification</h3>
            <div className="row mb-3">
              <div className="col-md-6">
                <label className="form-label">Location <span style={{color:"red",fontSize:"1rem"}}>*</span></label>
                <select
                  className="form-select"
                  value={newNotification.location}
                  onChange={handleLocationChange}
                >
                  <option value="">Select Location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-6">
                <label className="form-label">Title<span style={{color:"red",fontSize:"1rem"}}>*</span></label>
                <input
                  className="form-control"
                  name="title"
                  value={newNotification.title}
                  onChange={handleTitleChange}
                  placeholder="Enter Title to be displayed"
                />
              </div>

              <div className="col-md-6 mt-4">
                <label className="form-label">Last Date of Submission</label>
                <input
                type="date"
                  className="form-control"
                  name="submissionDate"
                  value={newNotification.submissionDate}
                  onChange={handleDateChange}
                  placeholder="Enter Last Date of Submission"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>
              <div className="col-md-6 mt-4">
                <label className="form-label">Upload File<span style={{color:"red",fontSize:"1rem"}}>*</span></label>
                <input
                  type="file"
                  className="form-control"
                  name="file"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                />
              </div>
              <div className="col-md-2 mt-2">
                <button
                  type="button"
                  className="btn btn-success mt-3"
                  onClick={handleSave}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
          <div className="ticket-tab">
            {/* <hr
              style={{
                height: "2px",
                backgroundColor: "green",
                margin: "4% 0",
              }}
            /> */}
            <div className="row mb-4">
            <div className="col-6"> 
                <h3>Manage Notifications</h3>
                  </div>
    
        <div className="col-6">
          <input
            type="text"
            className="form-control"
            placeholder="Search by title, location..."
            value={searchQuery}
            onChange={handleSearch}
          />
       
      </div>
      </div>
      <div className="table-responsive">
            <table className="table table-striped table-bordered table-hover">
              <thead>
                <tr>
                  <th style={{ width: "15%" }}>Location</th>
                  <th>Title</th>
                  <th>Date of Submission</th>
                  <th style={{ width: "15%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {viewNotifications.length > 0 ? (
                  viewNotifications.map((notification) => (
                    <tr key={notification.id}>
                      <td>{notification.location}</td>
                      <td>{notification.title}</td>
                      <td>{notification.submissionDate}</td>
                      <td>
                        <FaEye
                          className="me-2"
                          style={{ cursor: "pointer", color: "blue" }}
                          onClick={() => handleView(notification.id)}
                        />
                        <FaPencil
                          className="me-2"
                          style={{ cursor: "pointer", color: "orange" }}
                          onClick={() => handleEdit(notification.id)}
                        />
                        <FaTrash
                          style={{ cursor: "pointer", color: "red" }}
                          onClick={() => handleDelete(notification.id)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={4} className="text-center">
                      No Notifications Found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          

             <div className="row mt-4" style={{ "--bs-gutter-x": "0rem" }}>
                        <div className="col-5">
                          {totalItems > 0
                            ? `Showing ${startIndex + 1}-${endIndex} of ${totalItems}`
                            : "No items to display"}
                        </div>
                        <div className="col-7 d-flex justify-content-end">
                          <div className="d-flex align-items-center">
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handlePreviousPage}
                              disabled={currentPage === 1}
                            >
                              <FaAngleLeft />
                            </button>
            
                            <div className="mx-3 d-flex">
                              {getPageNumbers(currentPage, totalPages).map(
                                (pageNum, index) =>
                                  pageNum === "..." ? (
                                    <span key={`ellipsis-${index}`} className="mx-1">
                                      ...
                                    </span>
                                  ) : (
                                    <button
                                      key={pageNum}
                                      className={`btn mx-1 ${
                                        currentPage === pageNum
                                          ? "active btn-primary"
                                          : "btn-light"
                                      }`}
                                      onClick={() => handlePageChange(pageNum)}
                                    >
                                      {pageNum}
                                    </button>
                                  )
                              )}
                            </div>
            
                            <button
                              style={{
                                width: "35px",
                                height: "35px",
                                borderRadius: "50%",
                              }}
                              className="btn btn-success d-flex align-items-center justify-content-center"
                              onClick={handleNextPage}
                              disabled={currentPage >= totalPages}
                            >
                              <FaAngleRight />
                            </button>
                          </div>
                        </div>
                      </div>
                      </div>
          </div>

          {/* View Modal */}
          <Modal
            isOpen={isViewModalOpen}
            toggle={() => setIsViewModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsViewModalOpen(false)}>
              View Notification
            </ModalHeader>
            <ModalBody>
              {currentNotification && (
                <>
                  <h5>{currentNotification.title}</h5>
                  <iframe
                    src={currentNotification.file}
                    title="Notification File"
                    style={{ width: "100%", height: "350px" }}
                  ></iframe>
                </>
              )}
            </ModalBody>
          </Modal>

          {/* Edit Modal */}
          <Modal
            isOpen={isEditModalOpen}
            toggle={() => setIsEditModalOpen(false)}
            centered
          >
            <ModalHeader toggle={() => setIsEditModalOpen(false)}>
              Edit Notification
            </ModalHeader>
            <ModalBody>
              <div className="mb-3">
                <label className="form-label">Location<span style={{color:"red",fontSize:"1rem"}}>*</span></label>
                <select
                  className="form-select"
                  value={currentNotification?.location || ""}
                  onChange={(e) =>
                    setCurrentNotification((prev) => ({
                      ...prev,
                      location: e.target.value,
                    }))
                  }
                >
                  <option value="">Select Location</option>
                  {locations.map((loc, index) => (
                    <option key={index} value={loc}>
                      {loc}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                  Title<span style={{color:"red",fontSize:"1rem"}}>*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="editTitle"
                  value={editTitle}
                  onChange={(e) => setEditTitle(e.target.value)}
                  placeholder="Enter notification title"
                />
              </div>
              <div className="mb-3">
                <label htmlFor="editTitle" className="form-label">
                Last Date of Submission
                </label>
                <input
                  type="date"
                  className="form-control"
                  id="submissionDate"
                  value={currentNotification?.submissionDate}
                  onChange={(e) =>
                    setCurrentNotification((prev) => ({
                      ...prev,
                      submissionDate: e.target.value,
                    }))
                  }
                  placeholder="Enter Last Date of Submission"
                  onKeyDown={(e) => e.preventDefault()}
                />
              </div>

              <div className="mb-3">
                <label className="form-label">Upload New File (PDF only)</label>
                <input
                  type="file"
                  className="form-control"
                  ref={modalfileInputRef}
                />
              </div>
            </ModalBody>
            <ModalFooter className="flex-nowrap">
              <Button color="success" onClick={handleEditSave}>
                Save Changes
              </Button>
              <Button
                color="secondary"
                onClick={() => setIsEditModalOpen(false)}
              >
                Cancel
              </Button>
            </ModalFooter>
          </Modal>
        </div>
    
  );
};

export default Notifications;
